import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { RegistrationsViewModel } from "../../features/registrations/registrations-viewmodel";
import { UserIdViewModel } from "../../features/user-id/user-id-viewmodel";
import { useViewModel } from "../../viewmodel/use-view-model";
export const RegistrationsSearchView = observer(() => {
    const vm = useViewModel(RegistrationsViewModel);
    const vmUser = useViewModel(UserIdViewModel);
    const { t } = useTranslation();
    const inactiveRef = useRef(null);
    const handleCheckbox = () => vm.setAlsoInactive(inactiveRef.current?.checked || false, vmUser.userId);
    return (_jsx("div", { className: "ms-4 mt-4", children: _jsxs("div", { className: "form-check form-switch", children: [_jsx("input", { className: "form-check-input", type: "checkbox", ref: inactiveRef, onChange: handleCheckbox, checked: vm.alsoInactive }), _jsx("label", { className: "form-check-label", children: t("registrations.showInactive") })] }) }));
});
